import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startupSlugs: [],
  sliderData: {
    images: [],
    title: "",
  },
  subscribeModalDetails: {},
  commonData: {},
};

const sliderSlice = createSlice({
  name: "slider",
  initialState,
  reducers: {
    setStartupSlugs: (state, action) => {
      state.startupSlugs = action.payload;
    },
    setSliderData: (state, action) => {
      state.sliderData = action.payload;
    },
    setSubscribeModalDetails: (state, action) => {
      state.subscribeModalDetails = action.payload || {};
    },
    setCommonData: (state, action) => {
      state.commonData = action.payload || {};
    },
  },
});

// Export actions
export const {
  setStartupSlugs,
  setSliderData,
  setSubscribeModalDetails,
  setCommonData,
} = sliderSlice.actions;

// Export reducer
export default sliderSlice.reducer;
